import { render, staticRenderFns } from "./RelatedPlaces.vue?vue&type=template&id=5cb49607&scoped=true&"
import script from "./RelatedPlaces.vue?vue&type=script&lang=js&"
export * from "./RelatedPlaces.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPlaces.vue?vue&type=style&index=0&id=5cb49607&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb49607",
  null
  
)

export default component.exports